import { Box, Stack, Typography } from '@mui/material';

export function LinkUnavailablePage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        color: 'text.primary',
        px: 2,
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center" sx={{ maxWidth: 360 }}>
        <Typography variant="h6">Link no longer available</Typography>
        <Typography variant="body2" color="text.secondary">
          Please contact the shop directly for help with your service.
        </Typography>
      </Stack>
    </Box>
  );
}
